// extracted by mini-css-extract-plugin
module.exports = {"addToolButton":"tool-shed-automatic-search_addToolButton__9I454"};